/* eslint-disable no-use-before-define */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable import/extensions */
import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import StructureModel from '@Components/Results/structure/structure-model.service';
import StructureZoomService from '@Services/StructureZoom';
import Structure from '@Components/Results/structure/Structure';
import isEmpty from 'lodash/isEmpty';
import isArray from 'lodash/isArray';
import map from 'lodash/map';
import classnames from 'classnames';
import SubstanceIdentificationChemicalNamesList from '@Components/Results/substances/SubstanceIdentificationChemicalNamesList';
import { FEATURES } from '@Constants/rx-ui/constants';
import Auth from '@Services/Auth';

export default class SubstanceIdentificationData extends React.PureComponent {
  render() {
    const { metadata, database, details, zoom } = this.props;
    const zoomClasses = StructureZoomService.getZoomClasses('substances') || [];
    const zoomClass = zoomClasses[zoom];
    return (
      <>
        {renderIdentificationTable(details, database.isCIDatabase, database.isCommercialSupplierData)}
        <div className="align-structures">{renderMixtureItems(details.mixtureItems, database.id, zoomClass, zoom, metadata)}</div>
      </>
    );
  }
}

function renderIdentificationTable(details, isCIDatabase, isCommercialSupplierData) {
  const { id, type = [], formula, linearFormula, weight, referencesCount, modification, inChiKey, chemicalNames } = details;
  const casRegistryNumbers = (details.casRegistryNumbers || []).join(', ');
  const enableSUNIChemicalNamesChanges = Auth.isFeatureEnabled(FEATURES.enableSUNIChemicalNamesChanges);
  return (
    <table className="rx-substance-identification results-key-value-wrapper" id="rx-substance-identification">
      <tbody>
        <tr>
          <th className="header-cell" />
          <td />
          <th className="header-cell" />
          <td />
        </tr>
        {enableSUNIChemicalNamesChanges && <SubstanceIdentificationChemicalNamesList chemicalNames={chemicalNames} />}
        {!isCIDatabase ? (
          <tr className="ci-database-substance-row">
            <th className="header-cell header-substance-row-ci-database" scope="row">
              {isCommercialSupplierData ? 'Commercial Substances ID:' : 'Reaxys ID:'}
            </th>
            <InnerHTML tag="td" className="dangerously-set-td" html={id} />
            <th className="header-cell" />
            <td />
          </tr>
        ) : null}
        {!enableSUNIChemicalNamesChanges && chemicalNames ? (
          <tr className="chemical-names-substance-row">
            <th scope="row">Chemical Names:</th>
            <InnerHTML tag="td" className="dangerously-set-td" colSpan="3" html={chemicalNames.join(', ')} />
          </tr>
        ) : null}
        {casRegistryNumbers ? (
          <tr className="registry-numbers-substance-row">
            <th scope="row">CAS Registry Number(s):</th>
            <InnerHTML tag="td" className="dangerously-set-td" html={casRegistryNumbers} />
            {!isCIDatabase && !isEmpty(type) && (
              <>
                <th className="substance-type-th" scope="row">
                  Substance type:
                </th>
                <InnerHTML tag="td" className="substance-type-td" html={isArray(type) ? type.join(', ') : type} />
              </>
            )}
          </tr>
        ) : null}
        {formula || linearFormula ? (
          <tr className="formula-substance-row">
            <th scope="row">Molecular Formula:</th>
            <InnerHTML tag="td" className="formula-substance-td" html={formula} />
            {!isCommercialSupplierData && (
              <>
                <th scope="row">Linear Structure Formula:</th>
                <InnerHTML tag="td" className="liner-formula-substance-td" html={linearFormula} />
              </>
            )}
          </tr>
        ) : null}
        {isCommercialSupplierData && linearFormula ? (
          <tr className="commercial-supplier-data-substance-row">
            <th scope="row">Linear Structure Formula:</th>
            <InnerHTML tag="td" className="commercial-supplier-substance-td" html={linearFormula} />
          </tr>
        ) : null}
        {weight ? (
          <tr className="weight-substance-row">
            <th scope="row">Molecular Weight:</th>
            <InnerHTML tag="td" className="weight-substance-td" html={weight} />
            {!isCIDatabase && referencesCount ? (
              <th className="references-substance-th" scope="row">
                No of references:
              </th>
            ) : null}
            {!isCIDatabase && referencesCount ? <InnerHTML tag="td" className="references-substance-td" html={referencesCount} /> : null}
          </tr>
        ) : null}
        {modification ? (
          <tr className="modification-substance-row">
            <th scope="row">Modification:</th>
            <InnerHTML tag="td" colSpan="3" className="modification-substance-td" html={modification} />
          </tr>
        ) : null}
        {inChiKey ? (
          <tr className="chi-key-substance-row">
            <th scope="row">InChIKey:</th>
            <InnerHTML tag="td" className="chi-key-substance-td" html={inChiKey} />
          </tr>
        ) : null}
      </tbody>
    </table>
  );
}

function renderMixtureItems(items, databaseId, zoomClass, zoom, metadata = {}) {
  return map(items, (structure, index) => (
    <div className={classnames('mixture-structure-wrapper', zoomClass)} key={index}>
      <span className="structure-content-label">
        {structure.name} {structure.amount ? `(${structure.amount})` : ''}
      </span>
      <div className="mixture-structure mixture-structure--react">
        <Structure metadata={metadata} structure={formatStructure(structure, databaseId)} zoom={zoom} />
      </div>
    </div>
  ));
}

function formatStructure(structure, databaseId) {
  // eslint-disable-next-line no-param-reassign
  structure.databaseId = databaseId;
  return new StructureModel(structure);
}

SubstanceIdentificationData.propTypes = {
  metadata: MetadataPropTypesShape,
  details: PropTypes.shape({
    id: PropTypes.string,
    chemicalNames: PropTypes.array,
    casRegistryNumbers: PropTypes.array,
    type: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    formula: PropTypes.string,
    linearFormula: PropTypes.string,
    weight: PropTypes.string,
    referencesCount: PropTypes.string,
    modification: PropTypes.string,
    inChiKey: PropTypes.string,
    mixtureItems: PropTypes.array,
  }).isRequired,
  database: PropTypes.object.isRequired,
  zoom: PropTypes.number,
};
